import { render } from "./LocalRouteMap.vue?vue&type=template&id=0c1a595e&scoped=true"
import script from "./LocalRouteMap.vue?vue&type=script&lang=js"
export * from "./LocalRouteMap.vue?vue&type=script&lang=js"

import "./LocalRouteMap.vue?vue&type=style&index=0&id=0c1a595e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1a595e"]])

export default __exports__